/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Image, Text, View } from "@aws-amplify/ui-react";
export default function HeroSectionNew(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="1453px"
      height="694px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      backgroundColor="rgba(16,38,65,1)"
      {...getOverrideProps(overrides, "HeroSectionNew")}
      {...rest}
    >
      <Image
        width="1171px"
        height="694px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0px"
        left="363px"
        padding="0px 0px 0px 0px"
        objectFit="unset"
        {...getOverrideProps(overrides, "ikimy hero image 1")}
      ></Image>
      <View
        width="1513.28px"
        height="709px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="-2.16%"
        bottom="0%"
        left="0%"
        right="-4.15%"
        padding="0px 0px 0px 0px"
        backgroundImage="linear-gradient(0deg, rgba(34,66,114,1), rgba(34,66,114,0))"
        {...getOverrideProps(overrides, "Rectangle 39557")}
      ></View>
      <Flex
        gap="10px"
        direction="column"
        width="470px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="176px"
        left="103px"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "HeroHeader")}
      >
        <Flex
          gap="24px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 101")}
        >
          <Text
            fontFamily="Inter"
            fontSize="56px"
            fontWeight="700"
            color="rgba(254,254,254,1)"
            lineHeight="60px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Get Paid To&#x2028;Be Happy!"
            {...getOverrideProps(overrides, "Get Paid To\u2028Be Happy!")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="-0.25px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Imagine, the thrill you’ll feel as you enjoy a career where you’re respected, challenged and rewarded for your talents. You can have it all right now."
            {...getOverrideProps(
              overrides,
              "Imagine, the thrill you\u2019ll feel as you enjoy a career where you\u2019re respected, challenged and rewarded for your talents. You can have it all right now."
            )}
          ></Text>
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="8px"
            padding="12px 24px 12px 24px"
            backgroundColor="rgba(203,163,58,1)"
            {...getOverrideProps(overrides, "ButtonTesting")}
          >
            <Text
              fontFamily="Inter"
              fontSize="22px"
              fontWeight="700"
              color="rgba(255,255,255,1)"
              lineHeight="33px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Change Your Game! You’ll Like It."
              {...getOverrideProps(overrides, "label")}
            ></Text>
          </Flex>
        </Flex>
      </Flex>
    </View>
  );
}
